/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscWorldtimeRequest = { city: string };

export const GetMiscWorldtimeRequest$zodSchema: z.ZodType<
  GetMiscWorldtimeRequest
> = z.object({
  city: z.string().describe(
    "你需要查询的城市或地区，请使用标准的 IANA 时区数据库名称，例如 'Shanghai', 'Asia/Tokyo', 'America/New_York'。",
  ),
});

export type GetMiscWorldtimeNotFoundDetails = {};

export const GetMiscWorldtimeNotFoundDetails$zodSchema: z.ZodType<
  GetMiscWorldtimeNotFoundDetails
> = z.object({});

/**
 * 时区未找到。根据你提供的名称，未能找到对应的时区。请检查拼写或使用标准的 '洲/城市' 格式。
 */
export type GetMiscWorldtimeNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetMiscWorldtimeNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetMiscWorldtimeNotFoundResponseBody$zodSchema: z.ZodType<
  GetMiscWorldtimeNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscWorldtimeNotFoundDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "时区未找到。根据你提供的名称，未能找到对应的时区。请检查拼写或使用标准的 '洲/城市' 格式。",
);

export type GetMiscWorldtimeBadRequestDetails = {};

export const GetMiscWorldtimeBadRequestDetails$zodSchema: z.ZodType<
  GetMiscWorldtimeBadRequestDetails
> = z.object({});

/**
 * 请求参数错误。请检查你是否提供了 `city` 参数。
 */
export type GetMiscWorldtimeBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetMiscWorldtimeBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetMiscWorldtimeBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscWorldtimeBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscWorldtimeBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("请求参数错误。请检查你是否提供了 `city` 参数。");

/**
 * 查询成功！返回指定时区的详细时间信息。
 */
export type GetMiscWorldtimeResponseBody = {
  datetime?: string | undefined;
  offset_seconds?: number | undefined;
  offset_string?: string | undefined;
  query?: string | undefined;
  timestamp_unix?: number | undefined;
  timezone?: string | undefined;
  weekday?: string | undefined;
};

export const GetMiscWorldtimeResponseBody$zodSchema: z.ZodType<
  GetMiscWorldtimeResponseBody
> = z.object({
  datetime: z.string().optional(),
  offset_seconds: z.int().optional(),
  offset_string: z.string().optional(),
  query: z.string().optional(),
  timestamp_unix: z.int().optional(),
  timezone: z.string().optional(),
  weekday: z.string().optional(),
}).describe("查询成功！返回指定时区的详细时间信息。");

export type GetMiscWorldtimeResponse =
  | GetMiscWorldtimeResponseBody
  | GetMiscWorldtimeBadRequestResponseBody
  | GetMiscWorldtimeNotFoundResponseBody;

export const GetMiscWorldtimeResponse$zodSchema: z.ZodType<
  GetMiscWorldtimeResponse
> = z.union([
  z.lazy(() => GetMiscWorldtimeResponseBody$zodSchema),
  z.lazy(() => GetMiscWorldtimeBadRequestResponseBody$zodSchema),
  z.lazy(() => GetMiscWorldtimeNotFoundResponseBody$zodSchema),
]);
